export const PILLARS_ICON = "PillarsIcon";
export const ASCENDING_ICON = "AscendingIcon";
export const DESCENDING_ICON = "DescendingIcon";
